import { classNames } from "primereact/utils";

export const chip = {
  root: {
    className: classNames(
      "inline-flex items-center",
      "bg-[#E8DEF6] text-[#6E4299] rounded-[12px] px-2 mr-1",
    ),
  },
  label: "leading-2 py-1 text-[0.75rem]",
  icon: "leading-2 mr-2",
  image: {
    className: classNames("w-9 h-9 ml-[-0.75rem] mr-2", "rounded-full"),
  },
  removeIcon: {
    className: classNames(
      "ml-2 rounded-md transition duration-200 ease-in-out",
      "cursor-pointer hover:text-gray-400",
    ),
  },
};
